import { useState, useEffect } from 'react'

export type ContactInfo = {
  phone: string
  email: string
  address: string
  supportPhone: string
  supportEmail: string
}

const DEFAULTS: ContactInfo = {
  phone: '0333 996 4801',
  email: 'sales@directconnectwales.co.uk',
  address: 'Cardiff, Wales, UK',
  supportPhone: '0333 996 4801',
  supportEmail: 'support@directconnectwales.co.uk',
}

export function toTelHref(phone: string): string {
  return `tel:${phone.replace(/\s/g, '').replace(/^0/, '+44')}`
}

export function useContactDetails(): ContactInfo {
  const [details, setDetails] = useState<ContactInfo>(DEFAULTS)

  useEffect(() => {
    fetch('/api/contact-details')
      .then(r => r.json())
      .then(data => {
        if (data?.contactDetails) {
          const c = data.contactDetails
          setDetails({
            phone: c.phone || DEFAULTS.phone,
            email: c.email || DEFAULTS.email,
            address: c.address || DEFAULTS.address,
            supportPhone: c.supportPhone || c.phone || DEFAULTS.supportPhone,
            supportEmail: c.supportEmail || c.email || DEFAULTS.supportEmail,
          })
        }
      })
      .catch(() => { /* silently keep defaults */ })
  }, [])

  return details
}
